import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PublicRoute from './PublicRoute';
import ResetPasswordPage from 'pages/reset-password/ResetPasswordPage';

const App: React.FC = () => {
  return (
    <div style={{ height: "100%", minHeight: "100vh" }}>
      <Routes>
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPasswordPage />
            </PublicRoute>
          }
        />
      </Routes>
    </div>
  );
};

export default App;
